import { render, staticRenderFns } from "./error.vue?vue&type=template&id=10f7511e"
import script from "./error.js?vue&type=script&lang=js&external"
export * from "./error.js?vue&type=script&lang=js&external"
import style0 from "./error.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports